import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import VINStep from '../views/checkin/Vinstep';

const VINRequiredModal = ({ show, onHide, requestId, request, onVINVerified, onSkip }) => {
  if (!request) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fa-sharp fa-regular fa-barcode mr-2"></i>
          VIN Required
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-info mb-3">
          <i className="fa-sharp fa-regular fa-car mr-2"></i>
          <strong>{request.vehicleYear} {request.vehicleMake} {request.vehicleModel}</strong>
        </div>

        <VINStep
          requestId={requestId}
          vin=""
          onVINVerified={onVINVerified}
          hideStepHeader
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onSkip}>
          Complete Without VIN
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VINRequiredModal;
